import { useGetAllGeofences } from '@cobliteam/hooks/src/useEntity/useGeofenceV3';
import useQueryParamKey from '@cobliteam/hooks/src/useQueryParamKey';
import { useTranslation } from '@cobliteam/i18n';
import { usePermissions } from '@cobliteam/permissions';
import Button from '@cobliteam/ui/components/Button';
import { SelectVirtualized } from '@cobliteam/ui/form/Select';
import Icons from '@cobliteam/ui/icons';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedGeofenceId, setSelectedGeofenceId } from '../../../../store';

type SelectOption = {
  value: string;
  label: string;
};

const TrackingGeofenceRouterFilter = () => {
  const { t } = useTranslation('tracking');
  const dispatch = useDispatch();
  const { isAccessAllowed } = usePermissions();

  const isAllowedViewGeofences = isAccessAllowed('view:places-of-interest');
  const selectedGeofenceId = useSelector(selectSelectedGeofenceId);

  const { paramKey: paramGeofenceId, setParamKey: setParamGeofenceId } = useQueryParamKey('geofence_id');
  const { data: geofences, isLoading, error } = useGetAllGeofences({ options: { enabled: isAllowedViewGeofences } });
  const [selectedGeofenceIdState, setSelectedGeofenceIdState] = useState<string | undefined>(selectedGeofenceId || paramGeofenceId);

  const geofenceOptions: SelectOption[] = useMemo(() => {
    return (
      geofences?.map((geofence) => ({
        value: geofence.id,
        label: geofence.name || '',
      })) || []
    );
  }, [geofences]);

  const selectedGeofenceOption = geofenceOptions.find((option) => option.value === selectedGeofenceIdState);

  const handleClear = useCallback(() => {
    setSelectedGeofenceIdState(undefined);
    setParamGeofenceId('');
    dispatch(setSelectedGeofenceId(undefined));
  }, [dispatch, setParamGeofenceId]);

  useEffect(() => {
    dispatch(setSelectedGeofenceId(selectedGeofenceIdState || undefined));
  }, [selectedGeofenceIdState, dispatch]);

  if (error) return <div className='text-gray-500 text-sm'>{t('error_loading_triggers')}</div>;

  return (
    <div className='flex items-center gap-2'>
      <SelectVirtualized
        width={300}
        placeholder={t('select_place_of_interest')}
        value={selectedGeofenceOption}
        options={geofenceOptions}
        portal={false}
        disabled={isLoading}
        onValueChange={(option) => {
          setSelectedGeofenceIdState(option?.value || '');
        }}
      />
      {selectedGeofenceOption && <Button variant='outlined' onClick={handleClear} color='default' icon={<Icons name='x' />} />}
    </div>
  );
};

export default memo(TrackingGeofenceRouterFilter);
